import ShuffleSquares from './ShuffleSquares'

export default ShuffleSquares
